import React, { useEffect } from "react";
import './styles.css'
import BottomSheet from "../../../components/bottomsheet";
import { LuTextSearch } from "react-icons/lu";
import { Colors } from "../../../utils/constants/colors";
import { useAxios } from "../../../hooks/useAxios";
import { ApiCollection } from "../../../config/envConfig";
import { useNavigate, useSearchParams } from "react-router-dom";
import SpinnerLoader from "../../../components/loader";
import DataRenderer from "../../../components/render";
import { ExamSectionEnum } from "../../../utils/enums/exam";
import SubjectHeader from "../../../components/subjectHeader";


export default function TestGradingScreen() {

    useEffect(() => {
        getGrading();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const axios = useAxios();
    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const examId = searchParams.get('examId');
    const title = searchParams.get('title');

    const getGrading = async () => {
        setIsLoading(true);
        await axios.get(`${ApiCollection.subject.getGrading}?exam_id=${examId}`)
            .then((response) => {
                // console.log(response.data.questions);
                setQuestions(response.data.questions || []);
                setIsGraded(response.data.is_graded)
                setMetaData(response.data);

                // if (response.data.is_graded == false) {
                //     setTimeout(() => {
                //         getGrading();
                //     }, 3000);
                // }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching questions:', error);
                setIsLoading(false);
            });
    }

    const [selectedQuestion, setSelectedQuestion] = React.useState(0);
    const [isLoading, setIsLoading] = React.useState(false);
    const [showBottomSheet, setShowBottomSheet] = React.useState(false);
    const [metaData, setMetaData] = React.useState<any>(null);

    const [isGraded, setIsGraded] = React.useState(false);

    const [questions, setQuestions] = React.useState<any[]>([]);

    const onNext = () => {
        setSelectedQuestion(selectedQuestion + 1);
    }

    const onBack = () => {
        setSelectedQuestion(selectedQuestion - 1);
    }

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Loading...
                </h2>
            </div>
        )

    }

    if (questions.length === 0) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%', width: '100%' }}>
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    No questions found
                </h2>
            </div>
        )
    }

    if (isGraded === false) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Grading is in process..
                </h2>
                <p style={{ marginTop: 10, fontSize: 16, textAlign: 'center', width: '80%', color: 'gray' }}>
                    Please wait or come back later,  while we grade your answers !
                </p>
                <button className="go_home_button" onClick={() => navigate('/subject')}>
                    Go Home
                </button>
            </div>
        )
    }

    return (
        <div className="test_view_screen grading">
            <div className="test_wrapper">

                <SubjectHeader
                    title={''}
                    description=''
                    className='test'
                    right={
                        <button
                            onClick={() => navigate(`/test/analysis?examId=${examId}&title=${title}`)}
                            className='primary_btn view_analysis_on_grading'>View Analysis</button>
                    }
                />

                {
                    questions[selectedQuestion] &&
                    <div className="subject_view_question_holder">
                        <div className="subject_view_head_holder">
                            <h3>Question {questions[selectedQuestion].question_number} / {questions.length}</h3>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <LuTextSearch size={22}
                                    color={Colors.primary}
                                    onClick={() => setShowBottomSheet(true)}
                                    style={{ cursor: 'pointer', marginLeft: 10 }}
                                />
                            </div>
                        </div>
                        <p>
                            <DataRenderer
                                type='mathpix'
                                text={questions[selectedQuestion].question_text || ''}
                            />

                            <div className="question_image_container">
                                {
                                    questions[selectedQuestion].question_image &&
                                    questions[selectedQuestion].question_image.map((img: any) => (
                                        <div className="question_image_holder">
                                            <img
                                                src={img.url}
                                                alt="question"
                                                style={{ height: '100%', objectFit: 'contain', marginTop: 15 }}
                                            />
                                        </div>
                                    ))

                                }
                            </div>

                        </p>
                        <div className="subject_view_head_holder" style={{ marginTop: 20 }}>
                            <h3
                                style={{
                                    color: questions[selectedQuestion].marks_awarded === questions[selectedQuestion].marks ? Colors.success : Colors.error
                                }}
                            >Marks Obtained -  {questions[selectedQuestion].marks_awarded} / {questions[selectedQuestion].marks}</h3>
                        </div>
                    </div>
                }


                <div className="subject_view_question_holder answer">
                    {
                        (questions[selectedQuestion].question_type === ExamSectionEnum.MCQ || questions[selectedQuestion].options.length > 0) ?
                            <div className="answer_holder">
                                <div className="submitted_answer_holder mcq">

                                    <h3 className="section_heads">Submitted Answer</h3>
                                    {
                                        questions[selectedQuestion].student_answer == null &&
                                        <span style={{ color: 'gray', marginBottom: 10 }}>( Not Attempted )</span>
                                    }

                                    <div className="subject_view_option_holder">
                                        {
                                            questions[selectedQuestion].options.map((option: any, index: number) => (
                                                <div className={`subject_view_option ${questions[selectedQuestion].student_answer === option.option_text ? 'selected' : ''}  ${option.is_correct ? 'correct' : ''}`}>
                                                    {/* <input type="radio" name="option" id={`option_${option.option_text}`} /> */}
                                                    <div className={`radio ${questions[selectedQuestion].student_answer === option.option_text ? 'selected' : ''}`}>
                                                        {
                                                            option.is_correct ?
                                                                <div className="radio_inner_correct" />
                                                                :
                                                                questions[selectedQuestion].student_answer === option.option_text &&
                                                                <div className="radio_inner" />


                                                        }


                                                    </div>
                                                    <div style={{ width: '100%' }}>
                                                        <label>
                                                            <DataRenderer
                                                                type='mathpix'
                                                                text={option.option_text || ''}
                                                            />
                                                        </label>
                                                        <div className="question_image_container">
                                                            {
                                                                option.option_image_url &&

                                                                option.option_image_url.map((img: any) => (
                                                                    <div className="question_image_holder">
                                                                        <img
                                                                            src={img.url}
                                                                            alt="question"
                                                                            style={{ height: '100%', objectFit: 'contain', marginTop: 15 }}
                                                                        />
                                                                    </div>
                                                                ))

                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                </div>

                                <div className="model_answer_holder">
                                    {
                                        questions[selectedQuestion].classification
                                            && questions[selectedQuestion].classification.length > 0
                                            && questions[selectedQuestion].classification?.find((classify: any) => classify.classification !== 'totally_correct') ?
                                            (
                                                <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 20, marginBottom: 10, flexDirection: 'column' }}>
                                                    <h3 style={{ color: Colors.error, fontWeight: 'bold', textDecoration: 'underline' }}>What you did wrong !</h3>
                                                    <ol className="classification_holder">
                                                        {
                                                            questions[selectedQuestion].classification.map((classify: any) =>
                                                                classify.classification !== 'totally_correct' &&
                                                                (
                                                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 10, marginBottom: 10 }}>
                                                                        <span style={{ fontWeight: 'bold' }}>1.</span>

                                                                        <div style={{ marginLeft: 5 }}>
                                                                            <DataRenderer
                                                                                text={classify.content}
                                                                                type='mathpix'
                                                                            />
                                                                            <h3 style={{ fontWeight: 'bold', color: 'black', marginTop: 15, marginBottom: 5 }}>Reason - </h3>
                                                                            <p>{classify.reason}</p>

                                                                        </div>

                                                                    </div>
                                                                ))
                                                        }
                                                    </ol>
                                                </div>
                                            )
                                            :
                                            questions[selectedQuestion].classification?.find((classify: any,) => classify.classification === 'totally_correct') &&
                                            (
                                                <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 20, marginBottom: 10, flexDirection: 'column' }}>
                                                    <h3 style={{ color: Colors.success, fontWeight: 'bold', textDecoration: 'underline' }}>What you did right !</h3>
                                                    <ol className="classification_holder">
                                                        {
                                                            questions[selectedQuestion].classification.map((classify: any, index: any) =>
                                                                classify.classification === 'totally_correct' &&
                                                                (
                                                                    <li key={index}>
                                                                        {classify.reason}
                                                                    </li>
                                                                ))
                                                        }
                                                    </ol>
                                                </div>
                                            )


                                    }
                                </div>
                            </div>
                            :
                            <div className="answer_holder">


                                <div className={`submitted_answer_holder ${questions[selectedQuestion].student_answer ? 'divided' : ''}`}>
                                    <h3 className="section_heads ">Submitted Answer</h3>
                                    <div className="subject_view_text_answer">
                                        <p>
                                            <DataRenderer
                                                text={questions[selectedQuestion].student_answer || 'No answer submitted'}
                                                type='mathpix'
                                            />

                                        </p>
                                        {
                                            questions[selectedQuestion].classification
                                                && questions[selectedQuestion].classification.length > 0
                                                && questions[selectedQuestion].classification?.find((classify: any) => classify.classification !== 'totally_correct') ?
                                                (
                                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 30, marginBottom: 10, flexDirection: 'column' }}>
                                                        <h3 style={{ color: Colors.error, fontWeight: 'bold', textDecoration: 'underline' }}>What you did wrong !</h3>
                                                        <ol className="classification_holder">
                                                            {
                                                                questions[selectedQuestion].classification.map((classify: any) =>
                                                                    classify.classification !== 'totally_correct' &&
                                                                    (
                                                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 10, marginBottom: 10 }}>
                                                                            <span style={{ fontWeight: 'bold' }}>1.</span>

                                                                            <div style={{ marginLeft: 5 }}>
                                                                                <DataRenderer
                                                                                    text={classify.content}
                                                                                    type='mathpix'
                                                                                />
                                                                                <h3 style={{ fontWeight: 'bold', color: 'black', marginTop: 15, marginBottom: 5 }}>Reason - </h3>
                                                                                <p>{classify.reason}</p>

                                                                            </div>

                                                                        </div>
                                                                    ))
                                                            }
                                                        </ol>
                                                    </div>
                                                )
                                                :
                                                questions[selectedQuestion].classification?.find((classify: any) => classify.classification === 'totally_correct') &&
                                                (
                                                    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 10, marginBottom: 10, flexDirection: 'column' }}>
                                                        <h3 style={{ color: Colors.success, fontWeight: 'bold', textDecoration: 'underline' }}>What you did right !</h3>
                                                        <ol>
                                                            {
                                                                questions[selectedQuestion].classification.map((classify: any) =>
                                                                    classify.classification === 'totally_correct' &&
                                                                    (
                                                                        <li>
                                                                            {classify.reason}
                                                                        </li>
                                                                    ))
                                                            }
                                                        </ol>
                                                    </div>
                                                )


                                        }
                                    </div>
                                </div>

                                <div className="model_answer_holder">
                                    <h3 className="section_heads correct">Correct Answer</h3>
                                    <div className="subject_view_text_answer correct">
                                        <p>
                                            <DataRenderer
                                                text={questions[selectedQuestion].correct_answer || 'No model answer found'}
                                                type='mathpix'
                                            />

                                        </p>
                                    </div>
                                </div>

                            </div>
                    }
                </div>

                <BottomSheet
                    isOpen={showBottomSheet}
                    onClose={() => setShowBottomSheet(false)}
                    heading="Select Question"
                >
                    <div className="bottom_sheet_content">
                        <div className="question_list_header">
                            <div className="question_list_header_item">
                                <div className="question_list_box dummy selected">
                                    <span>1</span>
                                </div>
                                <span>Selected</span>
                            </div>

                            <div className="question_list_header_item">
                                <div className="question_list_box dummy unattempted">
                                    <span>1</span>
                                </div>
                                <span>Unattempted</span>
                            </div>

                            <div className="question_list_header_item">
                                <div className="question_list_box dummy submitted">
                                    <span>1</span>
                                </div>
                                <span>Submitted</span>
                            </div>
                        </div>

                        <div className="question_list">
                            {
                                questions.map((question: any, index: any) => (
                                    <div
                                        onClick={() => {
                                            setSelectedQuestion(index);
                                            setShowBottomSheet(false)
                                        }}
                                        className={`question_list_box ${question.is_submitted ? 'submitted ' : ' '} ${selectedQuestion === (index) ? 'selected' : ''}`}>
                                        <span>{question.question_number}</span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </BottomSheet>

                <div className="new_footer">
                    {
                        selectedQuestion > 0 ?
                            <button className="primary_btn outline subject_view_footer_button" onClick={onBack}>
                                <span>Back</span>
                            </button>
                            :
                            <button className="primary_btn outline subject_view_footer_button" style={{ opacity: 0 }} disabled>
                                <span>Back</span>
                            </button>
                    }

                    {
                        selectedQuestion === questions.length - 1 ?
                            <button className="primary_btn subject_view_footer_button" style={{ width: 'fit-content' }} onClick={() => {
                                if (metaData.subject_id) {
                                    navigate(`/subject/view?subjectId=${metaData.subject_id}&title=${metaData.subject}`)
                                } else {
                                    navigate(`/subject`)
                                }
                            }}>
                                <span>Take Another Test</span>
                            </button>
                            :
                            <button className="primary_btn subject_view_footer_button" onClick={onNext}>
                                <span>Next</span>
                            </button>
                    }


                </div>

            </div>
        </div>
    )
}

